<template>
  <div>
    <!-- Title -->
    <drop-down-menu-item :type="'title'">
      {{ group.title }}
    </drop-down-menu-item>

    <drop-down-menu-item
      v-for="link in customNavigationLinks"
      :key="link.displayName"
      :type="'link'"
      :href="link.link"
      :href-target="link.opensNewTab ? '_blank' : '_self'"
    >
      {{ link.displayName }}
    </drop-down-menu-item>
  </div>
</template>


<script>
  import DropDownMenuItem from '../drop-down-menu-item/index.vue';


  export default {
    name: 'CustomNavigation',

    components: {
      DropDownMenuItem
    },

    props: {
      group: {
        type: Object,
        required: true
      }
    },

    computed: {
      customNavigationLinks() {
        return this.group.links.filter(link => link.link);
      }
    }
  };
</script>
